import React from 'react';
import { Menu, Icon } from 'antd';
import logoThumb from '../assets/voicebase-logomark.svg';
import './Toolbox.less';
import ConnectionTool from './ConnectionTool';
import SchemaTool from './SchemaTool';
import DocumentationTool from './DocumentationTool';
import ExploreTool from './ExploreTool';
import Toolbar from '../components/Toolbar';

class Toolbox extends React.Component {
  state = {
    current: null,
  };

  handleClick = (e) => {
    this.setState({
      current: e.key,
    });
  };

  handleClose = () => {
    this.setState({
      current: null,
    });
  };

  renderTool() {
    const { current } = this.state;

    switch (current) {
      case 'connections':
        return (<ConnectionTool title="Connections" onClose={this.handleClose} />);
      case 'schema':
        return (<SchemaTool projectionKey="SCHEMA_TOOL" title="Schema" onClose={this.handleClose} />);
      case 'documentation':
        return (<DocumentationTool title="Documentation" onClose={this.handleClose} />);
      case 'explore':
        return (<ExploreTool title="Explore" onClose={this.handleClose} />);
      default:
        return undefined;
    }
  }

  render() {
    const { current } = this.state;

    return (
      <Toolbar
        onClose={this.handleClose}
        logo={(
          <div style={{ padding: '16px 0', textAlign: 'center' }}>
            <img style={{ height: '40px' }} alt="VoiceBase" src={logoThumb} />
          </div>
        )}
        menu={(
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[current]}
            onClick={this.handleClick}
            style={{ background: 'none' }}
          >
          {/*
            Temporarily disabling this option until we can fix its bugs.

            <Menu.Item key="explore" style={{ height: '64px', lineHeight: '64px' }}>
              <Icon style={{ transform: 'scale(2, 2)' }} type="compass" />
              <span>Explore</span>
            </Menu.Item>
          */}
            <Menu.Item key="schema" style={{ height: '64px', lineHeight: '64px' }}>
              <Icon style={{ transform: 'scale(2, 2)' }} type="cluster" />
              <span>Schema</span>
            </Menu.Item>
            <Menu.Item key="connections" style={{ height: '64px', lineHeight: '64px', marginBottom: '0' }}>
              <Icon style={{ transform: 'scale(2, 2)' }} type="api" />
              <span>Connections</span>
            </Menu.Item>
            <Menu.Item key="documentation" style={{ height: '64px', lineHeight: '64px', marginBottom: '0' }}>
              <Icon style={{ transform: 'scale(2, 2)' }} type="question-circle" />
              <span>Documentation</span>
            </Menu.Item>
          </Menu>
        )}
      >
        {this.renderTool()}
      </Toolbar>
    );
  }
}

export default Toolbox;
